import {Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import NetworkIcon from '@icons/NetworkIcon';

export default function NetworkButton(props: any) {
	const {t} = useTranslation();
	
	return (
		<Link to="/network" {...props}>
			<Stack direction="column" alignItems="center" spacing={0.5}>
				<NetworkIcon active={props['aria-selected']}/>
				<Typography fontSize={12}>{t('network')}</Typography>
			</Stack>
		</Link>
	);
}
